import React, { useEffect } from "react";
import { ProductsFiltersInput } from "../../../__generated__/globalTypes";
import { useProducts } from "../hooks";
import { Package } from "lucide-react";
import { Card } from "../../../components/cards";

export const ProductsInfos: React.FC<ProductsFiltersInput> = (where) => {
  const { data, loading } = useProducts({ where, limit: 99999, offset: 0 });

  return (
    <Card hover padding="sm" className="shadow-sm border border-gray-200">
      <div className="flex items-center justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
            Produits
          </p>
          <p className="text-sm sm:text-lg font-bold text-gray-900 truncate">
            {loading ? "Loading..." : data?.products?.total || 0}{" "}
          </p>
          <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
            Produits analysés
          </p>
        </div>
        <div className="bg-purple-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
          <Package className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" />
        </div>
      </div>
    </Card>
  );
};
